import React, { useState, useEffect, createRef } from 'react';
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-mysql";
import "ace-builds/src-noconflict/theme-textmate";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/theme-tomorrow";
import "ace-builds/src-noconflict/theme-twilight";
import "ace-builds/src-noconflict/theme-solarized_dark";
import "ace-builds/src-noconflict/theme-solarized_light";
import { uuidv4 } from '../../settings/shared/commonMethods';
import { SANotification } from '../SANotification';

const CodeHighlight = (props) => {

    const aceEditorRef = createRef();
    const [getCode, setCode] = useState("");

    var timeout = 0;
    useEffect(() => {
        if (typeof props.codeValue === "string") {
            setCode(props.codeValue)
        } else {
            var newArray = (props.codeValue !== null && props.codeValue.length !== 0) ? props.codeValue.join('') : props.codeValue.join('');
            // set the current state
            setCode(newArray)
        }

    }, [props]);

    const onChangeEditor = (code, index) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
            setCode(code)
            props._getNewCode(code, index, true)
        }, 600);
    }


    const onLoadFunction = editor => {
        editor.renderer.setScrollMargin(10, 10)
        editor.renderer.setPadding(10)

        // Undo
        editor.once("change", function () {
            editor.session.getUndoManager().reset();
        });

        // Cursor placed on end of line of code
        setTimeout(() => {
            var row = editor.session.getLength();
            editor.gotoLine(row); // Last line of row
            editor.execCommand("gotolineend"); // End of the line
        }, 50)
    }

    //keyboard shortcut
    const handlekeyDown = (e) => {
        var key = e.keyCode;
        switch (true) {
            case e.shiftKey && key === 13: // shift + enter press event here
                /** 
                * @param {*} user {currnetIndex, isSinglecell, cellFocusInsert}
                */
                props._codeCellRender(props.index, true, "focus");
                e.preventDefault();
                break;
            case e.ctrlKey && key === 13: //ctrl + Enter key press event her
                /**
                * 
                * @param {*} user {currnetIndex, isSinglecell, cellFocusInsert}
                */
                props._codeCellRender(props.index, true, "false");
                break;
            case (key === 18 && key === 13) || (e.altKey && key === 13): // alt + Enter key press event here
                /**
                * 
                * @param {*} user {currnetIndex, isSinglecell, cellFocusInsert}
                */
                props._codeCellRender(props.index, true, "insert");
                break;
            case e.ctrlKey && e.shiftKey && (key === 83 || key === 115): //ctrl + shift + s key press event here
                props._saveCellRender(props.tabIndex);
                SANotification({ type: "success", message: "Code Saved" })
                break;
            default:
                break
        }
    }

    return (
        <div className='codecell-margin' id={uuidv4()}>
            <div onKeyDown={handlekeyDown} >
                <AceEditor
                    ref={aceEditorRef}
                    className={`codeStyle div-code-style ${props.editorSettingsData.theme === "tomorrow" ? 'div-light-grey' : ''}`}
                    mode={props.language_mode}
                    theme={props.editorSettingsData.theme}
                    name={uuidv4()}
                    placeholder={props.language_mode === "mysql" ? "Type Sql Query" : "Type Code Snippet"}
                    onLoad={onLoadFunction}
                    focus={false}
                    onChange={code => onChangeEditor(code, props.index)}
                    fontSize={props.editorSettingsData.fontSize}
                    maxLines={Infinity}
                    wrapEnabled={props.editorSettingsData.options.includes("wrapEnabled")}
                    showPrintMargin={props.editorSettingsData.options.includes("showPrintMargin")}
                    showGutter={props.editorSettingsData.options.includes("lineNumber")}
                    highlightActiveLine={props.editorSettingsData.options.includes("highlightActiveLine")}
                    value={getCode}
                    readOnly={props.readOnly !== undefined ? props.readOnly : false}
                    setOptions={{
                        enableBasicAutocompletion: props.editorSettingsData.options.includes("autoComplete"),
                        enableLiveAutocompletion: props.editorSettingsData.options.includes("autoComplete"),
                        showLineNumbers: props.editorSettingsData.options.includes("lineNumber"),
                        tabSize: props.editorSettingsData.tabSize,
                        autoScrollEditorIntoView: true,
                        highlightSelectedWord: true,
                        cursorStyle: "smooth",
                        wrapBehavioursEnabled: true
                    }} />
            </div>
        </div>
    )
};

export default CodeHighlight;